import { hasKeysOfUnknown, isObject } from 'common/helpers'

import type { KeycloakConfig } from './types'

export async function getKeycloakConfig(): Promise<KeycloakConfig> {
  const req = await fetch('/utils/keycloakConfig.json')
  const json: unknown = await req.json()
  assertIsKeycloakConfig(json)
  return { ...json, code: window.btoa(`${json.clientId}:${json.code}`) }
}

function assertIsKeycloakConfig(json: unknown): asserts json is KeycloakConfig {
  if (isObject(json) && hasKeysOfUnknown(json, 'realm', 'clientId', 'code')) {
    return
  }

  throw new Error('неверный Keycloak config')
}
